import { FC } from 'react';
import { Tooltip as ReactTooltip, ITooltip } from 'react-tooltip';
import styled, { DefaultTheme } from 'styled-components';

const StyledTooltip = styled(ReactTooltip)(({ theme, maxWidth }: { theme: DefaultTheme; maxWidth?: string }) => {
  const { color, type } = theme.new;

  return `
    background-color: ${color.shade[1]};
    color: ${color.error[2]};
    font-family: ${type.face};
    font-size: ${type.size[14]};
    letter-spacing: 0.00219rem !important;
    font-weight: ${type.weight.regular};
    border-radius: 16px;
    padding: 0.75rem;
    border: 1px solid ${color.neutral[6]};
    box-shadow: 0px 1px 2px -2px rgba(16, 24, 40, 0.10), 0px 1px 3px 0px rgba(16, 24, 40, 0.10);
    ${maxWidth ? `max-width: ${maxWidth};` : ''}

    & > .styled-arrow {
      width: 8px;
      height: 8px;
      transform: rotate(45deg);
      position: absolute;
      background: inherit;
      box-shadow: 0px 1px 2px -2px rgba(16, 24, 40, 0.10), 0px 1px 3px 0px rgba(16, 24, 40, 0.10);
      border: 1px solid ${color.neutral[6]};

      &::before {
        background-color: inherit;
        top: -31%;
        left: -85%;
        width: 200%;
        height: 100%;
        display: block;
        position: absolute;
        content: ' ';
        transform: rotate(-45deg);
      }
    }
  `;
});

interface TooltipProps extends ITooltip {
  maxWidth?: string;
}

const Tooltip: FC<TooltipProps> = (props) => {
  const { id, children, maxWidth } = props;

  return (
    <StyledTooltip
      {...props}
      id={id}
      disableStyleInjection
      opacity={1}
      classNameArrow="styled-arrow"
      maxWidth={maxWidth}
    >
      <div aria-live="polite">{children}</div>
    </StyledTooltip>
  );
};

export default Tooltip;
